var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center d-flex flex-column justify-center align-center"},[_c('div',{staticClass:"secondary--text text-subtitle-1 mb-4"},[_vm._t("default")],2),_c('v-img',{staticClass:"mb-4",attrs:{"alt":"No document","src":require("@/assets/empty-state.svg"),"width":"60%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }